module.exports = __webpack_public_path__ + "static/1-834ee81a48f326f33f69d58a766aabaa.svg";